<template>
  <div class="identity-check">
    <i class="icon-logo"></i>
    <div class="bg">
      <div class="main-content">
        <tab :cur-step="activeStep"></tab>
        <body-check v-if="curStep === 1" @nextStep="nextStep"></body-check>
        <exam-notes v-if="curStep === 2"></exam-notes>
      </div>
    </div>
    <privacy-modal v-if="showPrivacyModal" @close="showPrivacyModal = false" @nextStep="nextStep"></privacy-modal>
  </div>
</template>

<script>
import { get } from '@/utils/ajax'
import Tab from './Tab'
import BodyCheck from './BodyCheck'
import PrivacyModal from './PrivacyModal'
import ExamNotes from './ExamNotes'

export default {
  components: {
    BodyCheck,
    Tab,
    PrivacyModal,
    ExamNotes
  },
  data() {
    return {
      showPrivacyModal: false,
      curStep: 0,
      activeStep: 0,
      needNotice: null,
      needIdentity: null
    }
  },
  async mounted () {
    // 为了兼容从其他系统直接跳转过来拿不到 localStorage 的情况
    if (this.$route.query.examId) {
      localStorage.setItem('examId', this.$route.query.examId)
    }

    if (!localStorage.examId) { // 从列表进入
      this.$router.push({ name: 'list' })
    }
    /**
     * 从其他系统直接跳转过来拿不到 localStorage，且有可能拿到的是上次考试的 localStorage
     * 所以去掉使用 localStorage 方式，改为直接读取接口
     */
    let needNotice = null
    let needIdentity = null
    try {
      const info = await get(`/home/edu/examineeExamRecode/check/status`, { examId: localStorage.examId }) // 考试信息
      const config = await get(`/home/exams/check/${localStorage.examId}`) // 配置信息
      this.$store.commit('SETSTATE', { key: 'examConfig', value: config })
      const item = config.exam_config.find(el => el.label === 'LARGE_EXAM#exam_notice')
      needNotice = `${item && item.actual_value === '1'}`
      needIdentity = `${info.examinee_status === 1 && info.verification_pass === 0 && config.identity_verification === 1}`
      localStorage.setItem('needNotice', needNotice)
      localStorage.setItem('needIdentity', needIdentity)
    } catch (e) { }
    this.needNotice = needNotice
    this.needIdentity = needIdentity

    if (needNotice === 'true' && needIdentity === 'false') {
      this.curStep = 2
      this.activeStep = 1
    } else if (needIdentity === 'true') {
      this.showPrivacyModal = true
      this.activeStep = 1
    } else {
      this.$router.push({ name: 'list' })
    }
    // const url = location.search
    // // 有这个参数说明是回调 不用打开
    // if (url.indexOf('&sign=') === -1) {
    //   this.showPrivacyModal = true
    // } else {
    //   this.curStep = 1
    // }
  },
  methods: {
    nextStep(step) {
      const needNotice = localStorage.getItem('needNotice') === 'true'
      if (step === 1 && !needNotice) {
        this.$router.push({ name: 'pretest' })
      } else {
        this.curStep = step + 1
        this.activeStep = this.curStep
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon-logo {
    display: inline-block;
    width: 275px;
    height: 40px;
    // background: url("~@/assets/images/logo.png") center / cover no-repeat;
    margin: 16px 0 44px 80px;
  }
  .identity-check {
    background-color: #fafafa;
    min-height: 100%;
    h2 {
      font-weight: 500;
      padding-top: 34px;
    }
  }
  .bg {
    max-width: 1580px;
    min-height: 800px;
    background: url("~@/assets/images/detect/bg.png") center / cover no-repeat;
    margin: 0 auto;
    padding-bottom: 90px;
  }
  .main-content {
    width: 1400px;
    min-height: 670px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 auto;
    box-shadow: 0 0 20px 0 rgba(57,126,253,0.1);
    border-radius: 8px;
    text-align: center;
  }
</style>
